import React from "react";


export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          {label}
        </label>
      )}
      <input
        className={`w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-colors text-base min-h-[48px] text-gray-900 placeholder:text-gray-400 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`}
        style={{ fontSize: '16px' }}
        {...props}
      />
      {error && (
        <p className="text-xs sm:text-sm text-red-600 mt-1">{error}</p>
      )}
    </div>
  );
}